import React from 'react';
import { toast } from 'react-toastify';
import type { SlopeKeycloak } from '../core/index.js';

export interface ToastAuthProps {
  message?: string;
  toastId: string;
  keycloak: SlopeKeycloak;
}

export const ToastAuth: React.FC<ToastAuthProps> = ({
  message = 'Your session is invalid or expired.',
  toastId,
  keycloak,
}) => {
  const handleLogin = () => {
    toast.dismiss(toastId);
    keycloak.instance.logout({
      redirectUri: window.location.href,
    });
  };

  return (
    <div
      role="group"
      aria-label="Authentication"
      style={{
        display: 'grid',
        gap: '10px',
        background: 'transparent',
        border: 0,
        color: 'inherit',
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: '0.95rem',
          lineHeight: 1.4,
          color: 'inherit',
          opacity: 0.9,
        }}
      >
        {message}
      </p>
      <button
        onClick={handleLogin}
        style={{
          appearance: 'none',
          border: 'none',
          borderRadius: '10px',
          padding: '8px 14px',
          fontWeight: 600,
          fontSize: '0.92rem',
          lineHeight: 1,
          cursor: 'pointer',
          background: '#2563eb',
          color: '#ffffff',
          boxShadow: '0 2px 0 rgba(0, 0, 0, 0.05)',
          transition: 'transform 100ms ease, box-shadow 120ms ease, filter 120ms ease',
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(37, 99, 235, 0.25)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = '';
          e.currentTarget.style.boxShadow = '0 2px 0 rgba(0, 0, 0, 0.05)';
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
        }}
        onFocus={(e) => {
          e.currentTarget.style.outline = '2px solid #60a5fa';
          e.currentTarget.style.outlineOffset = '2px';
        }}
        onBlur={(e) => {
          e.currentTarget.style.outline = '';
          e.currentTarget.style.outlineOffset = '';
        }}
      >
        Log in again
      </button>
    </div>
  );
};
